import React from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/imgs/logo.webp";
import jazzcashlogo from "../Assets/imgs/landing/jazzcashlogo.webp";

import { IgetMetaDataAndFlow } from "../@types/ApiResponses";

interface Props {
  planData: IgetMetaDataAndFlow;
  msisdn: string;
  error: string;
  btnDisable: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleContinue: () => void;
  priceState: {
    priceType: string;
    price: string;
  };
}

const LandingJazzCash = (props: Props) => {
  return (
    <div className="landing-section">
      <div className="landing-content">
        <div className="logo-image">
          <img
            src={props.planData.result?.logo}
            alt="Logo-image"
            width={120}
            height={82}
          />
        </div>
        <div className="landing-home-image">
          <img
            src={props.planData.result?.art_work}
            alt="landing-content-image"
            width={375}
            height={383}
          />
        </div>
        <div className="fusion-form jc--form">
          <div className="fikrfree--logo">
            <img src={logo} alt="logo" width={60} />
          </div>
          <div className="text">Please enter your Jazzcash number </div>
          <div className="jazzcash-input">
            <img src={jazzcashlogo} alt="jazz cash logo" />
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="3XX - XXXXXXX"
              maxLength={10}
              value={props.msisdn}
              onChange={props.handleChange}
            />
          </div>

          {props.error ? <p className="error">{props.error}</p> : null}

          <button
            onClick={props.handleContinue}
            disabled={props.btnDisable}
            className={props.btnDisable ? "disabled--btn" : ""}
          >
            Continue
          </button>
          {/* disabled button     */}
          {/* <button className="disabled--btn">Continue</button> */}
          {/* disabled button     */}
          <div className="pricing--policy">
            Price Point : Rs. {props.priceState.price}/
            {props.priceState.priceType} Inc.Tax
          </div>
          <div className="term-conditon">
            <Link to="/privacypolicy" target="_blank" rel="noreferrer">
              Privacy Policy
            </Link>
            <div className="dot"></div>
            <Link to="/terms" target="_blank" rel="noreferrer">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingJazzCash;
